import { render, staticRenderFns } from "./Resum.vue?vue&type=template&id=004c33ce&"
import script from "./Resum.vue?vue&type=script&lang=js&"
export * from "./Resum.vue?vue&type=script&lang=js&"
import style0 from "./Resum.vue?vue&type=style&index=0&id=004c33ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports